import React, {Component} from 'react';
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import {
    MAP_SUBTIPOS_ENTITY_CONFIG, ICONS, ICON_SCALE_DEFAULT
} from '../../../../config/globalFrontEndConfig.js'
import {normalizeName} from '../../../../Utils/Analizer.js'
import {arrayEquals} from '../../../../Utils/utils.js'
import loadGMaps from '../../../../scripts/loadGMaps.js';
import {PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN} from "../../../../App/RouterAdopta";
import {browserHistory} from "react-router";

let googleMapsAPI
let map;
let oms;
let CURRENT_BOUNDS;
let IS_USER_IN_MAP = false;
let markersInMap = {};
const USER_LOCATION_ID = "userLoc"
const CENTRO_MUNICIPIO_ID = "centroMunicipio"
let USER_IN_MAP = false
let markercentroMunicipio

let ACTIVE_INFO_WINDOW = {
    close: () => {
    }
};
const sanLorenzo = {lat: 40.591316, lng: -4.1789263};

const mapStyles = {
    default: [],
    hide: [
        {
            featureType: "poi.business",
            stylers: [{visibility: "off"}],
        },
        {
            featureType: "poi.government",
            stylers: [{visibility: "off"}],
        },
        {
            featureType: "poi.school",
            stylers: [{visibility: "off"}],
        },
        // {
        //     featureType: "landscape.man_made",
        //     stylers: [{visibility: "off"}],
        // },
        // {
        //     featureType: "transit",
        //     elementType: "labels.icon",
        //     stylers: [{visibility: "off"}],
        // },
        // {
        //     featureType: "poi.attraction",
        //     stylers: [{visibility: "off"}],
        // },
        // {
        //     featureType: "poi.medical",
        //     stylers: [{visibility: "off"}],
        // },
        // {
        //     featureType: "poi.park",
        //     stylers: [{visibility: "off"}],
        // },
        // {
        //     featureType: "poi.place_of_worship",
        //     stylers: [{visibility: "off"}],
        // },
        // {
        //     featureType: "poi.sports_complex",
        //     stylers: [{visibility: "off"}],
        // }
    ],
};

class MapContainer extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            scripts_maps_loaded: false
        }
        
        this.initMap = this.initMap.bind(this)
        this.initClusteredMap = this.initClusteredMap.bind(this)
        this.showMarkers = this.showMarkers.bind(this)
        this.hideMarkers = this.hideMarkers.bind(this)
        this.deleteAllMarkers = this.deleteAllMarkers.bind(this)
        this.deleteMarker = this.deleteMarker.bind(this)
        this.setMapOnAll = this.setMapOnAll.bind(this)
        this.addMarkerWithTimeout = this.addMarkerWithTimeout.bind(this)
        this.addMarkerToMap = this.addMarkerToMap.bind(this)
        this.handleLocationError = this.handleLocationError.bind(this)
        this.onSearchCurrentLocation = this.onSearchCurrentLocation.bind(this)
        this.onSearchInBoundsLocation = this.onSearchInBoundsLocation.bind(this)
        this.setBoundsMap = this.setBoundsMap.bind(this)
        this.setViewportMap = this.setViewportMap.bind(this)
        this.setUserLocationInMap = this.setUserLocationInMap.bind(this)
        this.setLocationInMap = this.setLocationInMap.bind(this)
    }
    
    
    createInfoWindowForMarker(info) {
        let imageSrc = info.image
        let nombre = info.nombre
        let subtipo_entity = info.subtipo
        let localizacion = info.locationStr
        let pathLink = PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", info.tipo).replace(":permalink", info.permalink) + "?utm_source=buscador&utm_medium=map"
        const contentString = '<a href="' + pathLink + '" target="_blank" class="listing-entities__item-a">' +
            '<div id="cardMap-' + info._id + '" class="cardMap-entities__item">' +
            '<div class="cardMap-entities__item-image">' +
            '<img loading="lazy" id="img-animal-" class="img-fluid" src="' + imageSrc + '"/>' +
            '</div>' +
            '<div class="cardMap-entities__item-info">' +
            '<div>' +
            '<div class="cardMap-entities__item-title">' +
            '<span class="cardMap-entities__item-title">' + nombre + '</span>' +
            '</div>' +
            '<div class="cardMap-entities__item-subtitle">' +
            '<span class="cardMap-entities__item-subtitle-current">' + subtipo_entity + '</span>' +
            '</div>' +
            '<div class="cardMap-entities__item-extra">' +
            '<i class="las la-lg la-map-marker-alt"></i>' +
            '<span class="cardMap-entities__item-extra-text">' + localizacion + '</span>' +
            '</div>' +
            '</div>' +
            // '<a data-id="" onClick=""href=""' +
            //    'class="btn btn-outline-primary btn-card-animal">Ver protectora</a>' +
            '</div>' +
            '</div>' +
            '<a>';
        
        
        const infoWindow = new googleMapsAPI.maps.InfoWindow({
            content: contentString,
            maxWidth: (this.props.config.mobileMode) ? 300 : 400,
            disableAutoPan: true,
            onClicSetted: false
        });
        
        return infoWindow
    }
    
    /**
     *
     * @param info
     * @param info.title
     * @param info.latLng ({lat:Number,lng:Number})
     * @param info.ico
     * @param info.colorIcon
     * @returns {*}
     */
    createSimpleMarker(info, map) {
        let opts = {
            position: info.latLng,
            map,
            animation: googleMapsAPI.maps.Animation.DROP,
            title: info.title,
            _id: info._id
            // label: {
            //     text: "\ue530",
            //     fontFamily: "Material Icons",
            //     color: "#ffffff",
            //     fontSize: "18px",
            // },
        }
        
        let icon
        if (info.imageIcon) {
            opts.icon = info.imageIcon
        } else if (info.icon) {
            opts.icon = {
                path: info.icon.icon[4],
                fillColor: info.colorIcon || "#0000ff",
                fillOpacity: 1,
                anchor: new googleMapsAPI.maps.Point(
                    info.icon.icon[0] / 2, // width
                    info.icon.icon[1] // height
                ),
                strokeWeight: 1,
                strokeColor: info.strokeColor || "#000000",
                scale: info.scale || ICON_SCALE_DEFAULT,
            }
        }
        const marker = new googleMapsAPI.maps.Marker(opts);
        if (oms) oms.addMarker(marker);  // adds the marker to the spiderfier _and_ the map
        return marker
    }
    
    toggleMarkerAnimation(currentElementHoverId) {
        // console.log("MapContainer::toggleMarkerAnimation() -> " + currentElementHoverId);
        //TODO 3/3/22 02:25: hacer que no salte el icono cuando se toca enversio movil
        
        Object.keys(markersInMap).forEach((id) => {
            markersInMap[id].setAnimation(null);
        })
        if (currentElementHoverId !== undefined && markersInMap[currentElementHoverId]) {
            markersInMap[currentElementHoverId].setAnimation(googleMapsAPI.maps.Animation.BOUNCE);
        }
    }
    
    addMarkerToMap(info, setInfoWindow = true) {
        if (markersInMap[info._id] && markersInMap[info._id].position.lat() === info.latLng.lat && markersInMap[info._id].position.lng() === info.latLng.lng) {
            // console.log("Marker[" + info._id + "] ya está en mapa");
        } else {
            // console.log("MapContainer::addMarkerToMap() -> " + info.title.slice(0, 12) + "...");
            // window.setTimeout(() => {
            
            const marker = this.createSimpleMarker(info, map)
            
            CURRENT_BOUNDS.extend(marker.getPosition());
            const that = this
            
            if (setInfoWindow) {
                
                const infoWindow = this.createInfoWindowForMarker(info)
                if (this.props.config.mobileMode) {
                    
                    // replace for spider_click event
                    if (oms) {
                        
                        googleMapsAPI.maps.event.addListener(marker, 'spider_click', function (e) {  // 'spider_click', not plain 'click'
                            // console.log("Marker::spider_click()");
                            ACTIVE_INFO_WINDOW.close();
                            infoWindow.open(map, marker);
                            ACTIVE_INFO_WINDOW = infoWindow
                            // marker.setAnimation(googleMapsAPI.maps.Animation.BOUNCE);
                            that.props.onMouseOverElement(info._id)
                        });
                    } else {
                        
                        marker.addListener("click", () => {
                            // console.log("Marker::click()");
                            ACTIVE_INFO_WINDOW.close();
                            infoWindow.open(map, marker);
                            ACTIVE_INFO_WINDOW = infoWindow
                            // marker.setAnimation(googleMapsAPI.maps.Animation.BOUNCE);
                            this.props.onMouseOverElement(info._id)
                        });
                    }
                    
                    
                    googleMapsAPI.maps.event.addListener(infoWindow, 'domready', function () {
                        // console.log("MapContainer::googleMapsAPI.map::onDomReadey()");
                        if (!infoWindow.onClicSetted) {
                            document.getElementById("cardMap-" + info._id).addEventListener("click", () => {
                                that.props.onClickCard(info._id)
                            });
                            infoWindow.onClicSetted = true
                        }
                    });
                    
                } else {
                    
                    // replace for spider_click event
                    let pathLink = PATH_BUSCADOR_PETFRIENDLY_DETAIL_PERMALINK_PATTERN.replace(":tipo_entity", info.tipo).replace(":permalink", info.permalink) + "?utm_source=buscador&utm_medium=map"
                    if (oms) {
                        googleMapsAPI.maps.event.addListener(marker, 'spider_click', function (e) {  // 'spider_click', not plain 'click'
                            // console.log("Marker::spider_click()");
                            // console.log("Marker::click()");
                            browserHistory.push(pathLink)
                            that.props.onClickCard(info._id)
                        });
                    } else {
                        marker.addListener("click", () => {
                            // console.log("Marker::click()");
                            browserHistory.push(pathLink)
                            this.props.onClickCard(info._id)
                        });
                    }
                    
                    marker.addListener('mouseover', (e) => {
                        // console.log("Marker::mouseover()");
                        infoWindow.open(map, marker);
                        // marker.setAnimation(googleMapsAPI.maps.Animation.BOUNCE)
                        // that.toggleMarkerAnimation(info._id)
                        // this.props.onMouseOverElement(info._id)
                    });
                    // assuming you also want to hide the infowindow when user mouses-out
                    marker.addListener('mouseout', (e) => {
                        // console.log("Marker::mouseout()");
                        infoWindow.close();
                        marker.setAnimation(null);
                        // this.props.onMouseOverElement(undefined)
                    });
                }
            }
            
            
            markersInMap[info._id] = marker
        }
        return markersInMap[info._id]
        
    }
    
    
    addMarkerWithTimeout(info, timeout) {
        return new Promise((resolve, reject) => {
            
            // console.log("MapContainer::addMarkerWithTimeout() -> " + info.title.slice(0, 12) + "...");
            window.setTimeout(() => {
                
                const marker = this.createSimpleMarker(info, map)
                markersInMap[info._id] = marker
                CURRENT_BOUNDS.extend(marker.getPosition());
                
                const infoWindow = new googleMapsAPI.maps.InfoWindow();
                
                // Add a click listener for each marker, and set up the info window.
                marker.addListener("click", () => {
                    infoWindow.close();
                    infoWindow.setContent(marker.getTitle());
                    infoWindow.open(marker.getMap(), marker);
                });
                
                resolve()
            }, timeout);
        });
    }
    
    setMapOnAll(map) {
        // console.log("MapContainer::setMapOnAll()");
        Object.keys(markersInMap).forEach((key) => {
            markersInMap[key].setMap(map);
        })
    }
    
    // Removes the markers from the map, but keeps them in the array.
    hideMarkers() {
        // console.log("MapContainer::hideMarkers()");
        this.setMapOnAll(null);
    }
    
    // show the markers from the map, but keeps them in the array.
    showMarkers() {
        // console.log("MapContainer::hideMarkers()");
        this.setMapOnAll(map);
    }
    
    
    // Deletes all markers in the array by removing references to them.
    deleteAllMarkers() {
        // console.log("MapContainer::deleteAllMarkers()");
        this.hideMarkers();
        // bounds = new googleMapsAPI.maps.LatLngBounds();
        markersInMap = {}
    }
    
    deleteMarker(marker) {
        if (marker) {
            marker.setMap(null)
        }
    }
    
    setMapHeight() {
        $("#map").height($(window).height() - $("#map").offset()?.top || 100);
    }
    
    
    mapFitBounds(latLngBounds) {
        // console.log("markers on map -> " + (Object.keys(markersInMap).length) + " -> fit bounds");
        if (latLngBounds !== undefined) {
            map?.fitBounds(latLngBounds);
        } else if (!markersInMap || Object.keys(markersInMap).length === 0) {
            map?.setZoom(11)
        } else if (markersInMap && Object.keys(markersInMap).length <= 1) {
            map?.setCenter(markersInMap[Object.keys(markersInMap)[0]].position);
            map?.setZoom(11)
        } else {
            map?.fitBounds(CURRENT_BOUNDS);
        }
    }
    
    setViewportMap() {
        //set viewport
        if (this.props.userLocation && this.props.userLocation.useUserLocation) {
            
            if (!this.isSameLocation(this.props.userLocation, (markersInMap[USER_LOCATION_ID]) ? markersInMap[USER_LOCATION_ID].position : undefined)) {
                // console.log("loc del user ha cambiado");
                this.setUserLocationInMap()
                this.mapFitBounds()
            } else {
                // console.log("loc del user no ha cambiado");
            }
            this.deleteMarker(markercentroMunicipio)
            // } else if (this.props.geoInBounds && this.props.geoInBounds.useGeoInBounds) {
            // console.log("set viewport ");
            // this.setBoundsMap()
        } else if (this.props.entitiesList) {
            if (this.props.location && this.props.location.center) {
                this.setLocationInMap()
            }
            if (this.props.entitiesList.length === 1 && this.props.viewport) {
                this.setBoundsMap(this.props.viewport);
            } else {
                this.mapFitBounds()
            }
            
            
        } else if (this.props.viewport) {
            this.setBoundsMap(this.props.viewport);
        }
        
        if (this.props.location && this.props.location.center) {
            this.setLocationInMap()
            this.mapFitBounds()
        }
        
    }
    
    // setMarkers(map) {
    //     console.log("MapContainer::setMarkers()");
    //     CURRENT_BOUNDS = new googleMapsAPI.maps.LatLngBounds();
    //     // Adds markers to the map.
    //     for (let i = 0; i < neighborhoods.length; i++) {
    //         const loc = neighborhoods[i];
    //         const marker = new googleMapsAPI.maps.Marker({
    //             position: {lat: loc.lat, lng: loc.lng},
    //             map,
    //             title: "marker-" + i,
    //         });
    //         CURRENT_BOUNDS.extend(marker.getPosition());
    //     }
    //
    //     if (CURRENT_MARKERS && CURRENT_MARKERS.length > 1) {
    //         map.fitBounds(CURRENT_BOUNDS);
    //     }
    // }
    
    initClusteredMap() {
        // console.log("MapContainer::initClusteredMap()");
        
        CURRENT_BOUNDS = new googleMapsAPI.maps.LatLngBounds();
        
        
        const map = new googleMapsAPI.maps.Map(document.getElementById("map"), {
            zoom: 3,
            center: sanLorenzo,
        });
        const infoWindow = new googleMapsAPI.maps.InfoWindow({
            content: "",
            disableAutoPan: true,
        });
        // Create an array of alphabetical characters used to label the markers.
        const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        // Add some markers to the map.
        const markers = neighborhoods.map((position, i) => {
            const label = labels[i % labels.length];
            const marker = new googleMapsAPI.maps.Marker({
                position,
                label,
            });
            CURRENT_BOUNDS.extend(marker.getPosition());
            
            
            // markers can only be keyboard focusable when they have click listeners
            // open info window when marker is clicked
            marker.addListener("click", () => {
                infoWindow.setContent(label);
                infoWindow.open(map, marker);
            });
            return marker;
        });
        // this.setMapHeight()
        this.mapFitBounds()
        
        
        // Add a marker clusterer to manage the markers.
        new MarkerClusterer({markers, map});
    }
    
    
    onSearchInBoundsLocation(callback) {
        // console.log("MapContainer::onSearchInBoundsLocation()");
        const bounds = map.getBounds()
        const center = map.getCenter()
        
        let northEastPoint = {
            lat: bounds.getNorthEast().lat(),
            lng: bounds.getNorthEast().lng()
        }
        let southWestPoint = {
            lat: bounds.getSouthWest().lat(),
            lng: bounds.getSouthWest().lng()
        }
        // let boundsArray = [[NorthEastPoint.lng, NorthEastPoint.lat], [SouthWestPoint.lng, SouthWestPoint.lat]]
        let boundsView = {
            northeast: northEastPoint,
            southwest: southWestPoint
        }
        let boundsObj = {
            center: {
                latLng: {
                    lat: center.lat(),
                    lng: center.lng()
                },
                centerArray: [center.lng(), center.lat()]
            },
            // bounds: boundsArray
            bounds: boundsView
        }
        // console.log("centerBounds = '" + JSON.stringify(boundsObj.center.latLng) + "'");
        
        this.props.onSearchInBoundsLocation(boundsObj)
        callback()
    }
    
    onSearchCurrentLocation(callback) {
        // console.log("MapContainer::onSearchCurrentLocation()");
        // let infoWindow = new googleMapsAPI.maps.InfoWindow();
        
        
        // if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(
        //         (position) => {
        //             const pos = {
        //                 lat: position.coords.latitude,
        //                 lng: position.coords.longitude,
        //             };
        
        this.props.onSearchCurrentLocation()
        
        // console.log("Posicion del user");
        // console.log(pos);
        // let infoWindow = new googleMapsAPI.maps.InfoWindow();
        //
        //
        // infoWindow.setPosition(pos);
        // infoWindow.setContent("Estás aquí");
        // infoWindow.open(map);
        // map.setCenter(pos);
        //
        // callback()
        // },
        // () => {
        //     this.handleLocationError(true, infoWindow, map.getCenter());
        //     callback()
        // }
        // );
        // } else {
        //     Browser doesn't support Geolocation
        // this.handleLocationError(false, infoWindow, map.getCenter());
        // callback()
        // }
        
        
    }
    
    
    setUserLocationInMap() {
        if (this.props.userLocation?.useUserLocation && this.props.userLocation?.lat && this.props.userLocation?.lng) {
            let infoWindow = new googleMapsAPI.maps.InfoWindow();
            
            const latLng = {lat: this.props.userLocation.lat, lng: this.props.userLocation.lng}
            const info = {
                _id: USER_LOCATION_ID,
                latLng: latLng,
                // title: "Estás aquí",
                icon: ICONS[USER_LOCATION_ID].faIcon,
                colorIcon: ICONS[USER_LOCATION_ID].colorIcon,
                strokeColor: ICONS[USER_LOCATION_ID].strokeColor,
                scale: (this.props.config.mobileMode) ? ICONS[USER_LOCATION_ID].scaleMobile : ICONS[USER_LOCATION_ID].scale,
                imageIcon: ICONS[USER_LOCATION_ID].imageIcon,
            }
            // console.log("ICON scale = '" + ((this.props.config.mobileMode)?ICONS[_id].scaleMobile:ICONS[_id].scale) + "'");
            const marker = this.addMarkerToMap(info, false)
            
            
            let elements = document.querySelectorAll(".buttonBuscarCerca >i")
            if (elements) {
                elements.forEach((element) => {
                    element.classList.remove('spin');
                    element.classList.remove('la-sync-alt');
                    element.classList.add('la-crosshairs');
                })
            }
            
            USER_IN_MAP = true
            
            infoWindow.setPosition(latLng);
            infoWindow.setContent('<div style="padding:0 0.5rem;">Estás aquí <i class="las la-smile"></i><div/>');
            if (this.props.config.mobileMode) {
                marker.addListener("click", () => {
                    ACTIVE_INFO_WINDOW.close();
                    infoWindow.open(map, marker);
                    ACTIVE_INFO_WINDOW = infoWindow
                });
                
            } else {
                marker.addListener('mouseover', (e) => {
                    ACTIVE_INFO_WINDOW.close();
                    infoWindow.open(map, marker);
                    ACTIVE_INFO_WINDOW = infoWindow
                });
                marker.addListener('mouseout', (e) => {
                    infoWindow.close();
                });
                
                if (markersInMap && Object.keys(markersInMap).length > 1) {
                    this.mapFitBounds()
                }
            }
        }
    }
    
    setLocationInMap() {
        if (this.props.location && this.props.location.center) {
            
            const latLng = {lat: this.props.location.center.lat, lng: this.props.location.center.lng}
            const _id = CENTRO_MUNICIPIO_ID
            const info = {
                _id: _id,
                latLng: latLng,
                // title: "Estás aquí",
                // icon: ICONS[_id].icon,
                // colorIcon: ICONS[_id].color,
                // strokeColor: ICONS[_id].strokeColor,
                // scale: ICONS[_id].scale,
                // imageIcon: ICONS[_id].imageIcon,
            }
            markercentroMunicipio = this.addMarkerToMap(info, false)
        }
    }
    
    setBoundsMap(viewport) {
        if (viewport) {
            const latLngBounds = new googleMapsAPI.maps.LatLngBounds();
            
            latLngBounds.extend(new googleMapsAPI.maps.LatLng(viewport.northeast));
            latLngBounds.extend(new googleMapsAPI.maps.LatLng(viewport.southwest));
            this.mapFitBounds(latLngBounds)
            
            // } else if (this.props.geoInBounds && this.props.geoInBounds.useGeoInBounds) {
            //
            //     const bounds = this.props.geoInBounds.bounds;
            //     const latLngBounds = new googleMapsAPI.maps.LatLngBounds();
            //
            //     // latLngBounds.extend(new googleMapsAPI.maps.LatLng(bounds[0][1], bounds[0][0]));
            //     // latLngBounds.extend(new googleMapsAPI.maps.LatLng(bounds[1][1], bounds[1][0]));
            //     latLngBounds.extend(new googleMapsAPI.maps.LatLng(bounds.northeast.lat, bounds.northeast.lng));
            //     latLngBounds.extend(new googleMapsAPI.maps.LatLng(bounds.southwest.lat, bounds.southwest.lng));
            //     // this.setMapHeight()
            //     console.log("MapContainer::setBoundsMap()");
            //     this.mapFitBounds(latLngBounds)
        }
        
    }

// Initialize and add the map
    initMap() {
        // console.log("MapContainer::initMap()");
        // The location of Uluru
        // The map, centered at Uluru
        
        if (!googleMapsAPI) {
            console.error("Google Maps API has not loaded yet!")
        } else {
            
            const options = {
                zoom: 6,
                center: sanLorenzo,
                // gestureHandling: "cooperative",
                gestureHandling: "greedy",
                // mapId: "8e0a97af9386fef",
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: (!this.props.config || this.props.config.mobileMode === true) ? false : true
                
            }
            map = new googleMapsAPI.maps.Map(document.getElementById("map"), options);
            map.setOptions({styles: mapStyles["hide"]});
            
            try {
                // https://github.com/jawj/OverlappingMarkerSpiderfier
                oms = new OverlappingMarkerSpiderfier(map, {
                    markersWontMove: true,
                    markersWontHide: true,
                    basicFormatEvents: true
                });
            } catch (e) {
                console.warn("OverlappingMarkerSpiderfier not defined");
            }
            
            map.addListener("click", (mapsMouseEvent) => {
                // console.log("Map::onClick() -> " + JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2));
                ACTIVE_INFO_WINDOW.close()
                this.toggleMarkerAnimation()
            });
            
            CURRENT_BOUNDS = new googleMapsAPI.maps.LatLngBounds();
            
            this.deleteAllMarkers()
            const that = this;
            googleMapsAPI.maps.event.addListenerOnce(map, 'idle', function () {
                // console.log("googleMapsAPI.maps.event.addListenerOnce(map, 'idle')");
                if (that.props.entitiesList) {
                    that.mapFitBounds()
                } else {
                    that.setBoundsMap(that.props.viewport)
                }
            });
            
            
            const divContainer = document.createElement("div");
            const divButtons = document.createElement("div");
            const buttonResults = document.createElement("button");
            buttonResults.id = "buttonResults"
            
            let text = 'Mostrando <span id="resultInMap" class="bold">' + Object.keys(markersInMap).length + '</span>' + ' de <span id="totalResults" class="bold">' + this.props.totalResults + '</span> resultados';
            buttonResults.innerHTML = text
            
            buttonResults.classList.add("custom-map-control-button");
            buttonResults.classList.add("custom-map-control-button-results");
            
            if (markersInMap && Object.keys(markersInMap).length === 0 || !this.props.totalResults) {
                buttonResults.style.visibility = "hidden";
            }
            const locationButton = document.createElement("button");
            
            
            locationButton.id = "buttonBuscarCerca"
            locationButton.classList.add("custom-map-control-button");
            locationButton.classList.add("buttonBuscarCerca");
            locationButton.style.fontFamily = "Comfortaa,Arial,sans-serif";
            locationButton.innerHTML = '<i class="las la-crosshairs"></i> Cerca de mi';
            
            // map.controls[googleMapsAPI.maps.ControlPosition.TOP_RIGHT].push(locationButton);
            locationButton.addEventListener("click", () => {
                // Try HTML5 geolocation.
                let elements = document.querySelectorAll(".buttonBuscarCerca > i")
                if (elements) {
                    elements.forEach((element) => {
                        
                        element.classList.remove('la-crosshairs');
                        element.classList.add('la-sync-alt');
                        element.classList.add('spin');
                    })
                }
                
                that.onSearchCurrentLocation()
                
            });
            
            
            const searchInBoundsButton = document.createElement("button");
            searchInBoundsButton.id = "buttonBuscarEnZona"
            searchInBoundsButton.classList.add("custom-map-control-button");
            searchInBoundsButton.style.fontFamily = "Comfortaa,Arial,sans-serif";
            searchInBoundsButton.innerHTML = '<i class="las la-map-marked"></i> Buscar en esta zona';
            
            searchInBoundsButton.addEventListener("click", () => {
                // Try HTML5 geolocation.
                
                let element = document.querySelector(".custom-map-control-button .la-map-marked")
                element.classList.remove('la-map-marked');
                element.classList.add('la-sync-alt');
                element.classList.add('spin');
                
                that.onSearchInBoundsLocation(() => {
                    element.classList.remove('spin');
                    element.classList.remove('la-sync-alt');
                    element.classList.add('la-map-marked');
                })
                
                
            });
            
            
            divButtons.appendChild(searchInBoundsButton);
            divButtons.appendChild(locationButton);
            
            
            // divContainer.appendChild(divButtons);
            divContainer.appendChild(buttonResults);
            
            map.controls[googleMapsAPI.maps.ControlPosition.TOP_RIGHT].push(locationButton);
            map.controls[googleMapsAPI.maps.ControlPosition.TOP_LEFT].push(searchInBoundsButton);
            map.controls[googleMapsAPI.maps.ControlPosition.TOP_CENTER].push(divContainer);
            
            
            // console.log("poniendo markers")
            // for (let i = 0; i < neighborhoods.length; i++) {
            //     this.addMarkerWithTimeout(neighborhoods[i], i * 200);
            // }
            
            // this.setMarkers(map)
            // The marker, positioned at Uluru
            
            
            // setInterval(() => {
            //     console.log("borrando markers")
            //     this.deleteAllMarkers();
            //
            // }, 2000)
            //
            // setInterval(() => {
            //     console.log("poniendo markers")
            //     this.addSimpleMarker(sanLorenzo)
            //     this.addSimpleMarker(sanLorenzo2)
            //     this.addSimpleMarker(sanLorenzo3)
            //
            // }, 4000)
            
            // console.log("set clustered markers map");
            // new MarkerClusterer({ markers, map });
            // const markerCluster = new MarkerClusterer({ map, markers });
            
            
            // const hideMarkersButton = document.createElement("button");
            //
            // hideMarkersButton.textContent = "hide markers";
            // hideMarkersButton.classList.add("custom-map-control-button");
            // map.controls[googleMapsAPI.maps.ControlPosition.LEFT_BOTTOM].push(hideMarkersButton);
            // hideMarkersButton.addEventListener("click", () => {
            //     // Try HTML5 geolocation.
            //     that.hideMarkers()
            // });
            //
            //
            // const showMarkersButton = document.createElement("button");
            //
            // showMarkersButton.textContent = "show markers";
            // showMarkersButton.classList.add("custom-map-control-button");
            // map.controls[googleMapsAPI.maps.ControlPosition.RIGHT_BOTTOM].push(showMarkersButton);
            // showMarkersButton.addEventListener("click", () => {
            //     // Try HTML5 geolocation.
            //     that.showMarkers()
            // });
            
        }
        
    }
    
    
    handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation
                ? "Error: El servicio de geolocalización falló."
                : "Error: Tu navegador no soporta la geolocalización."
        );
        infoWindow.open(map);
    }
    
    
    putEntitiesInMap(entities) {
        CURRENT_BOUNDS = new googleMapsAPI.maps.LatLngBounds();
        
        const arrayLocsPromise = []
        for (let i = 0; i < entities.length; i++) {
            let entity = entities[i]
            
            if (!markersInMap[entity._id]) {
                
                let srcImage = entity.img_principal && entity.img_principal.url
                    ? entity.img_principal.url
                    : `${process.env.CDN_URL}/images/adoptaunanimal/default/${entity.tipo.toLowerCase()}2.png`
                // : getImageEncode("default." + "protectora")
                const tipo = normalizeName(entity.tipo)
                const subtipo = normalizeName(entity.subtipo)
                const info = {
                    _id: entity._id,
                    permalink: entity.permalink,
                    nombre: entity.nombre,
                    image: srcImage,
                    locationStr: entity.locationStr,
                    tipo: entity.tipo,
                    subtipo: (entity.subtipo) ? entity.subtipo : entity.tipo,
                    latLng: {
                        lat: entity.location.coordinates[1],
                        lng: entity.location.coordinates[0]
                    },
                    title: entity.nombre,
                    icon: MAP_SUBTIPOS_ENTITY_CONFIG[tipo][subtipo].faIcon,
                    colorIcon: MAP_SUBTIPOS_ENTITY_CONFIG[tipo][subtipo].colorIcon,
                    strokeColor: MAP_SUBTIPOS_ENTITY_CONFIG[tipo][subtipo].strokeColor,
                    scale: (this.props.config.mobileMode) ? MAP_SUBTIPOS_ENTITY_CONFIG[tipo][subtipo].scaleMobile : MAP_SUBTIPOS_ENTITY_CONFIG[tipo][subtipo].scale,
                }
                // console.log("ICON scale = '" + ((this.props.config.mobileMode)?ICONS[entity.tipo][entity.subtipo].scaleMobile:ICONS[entity.tipo][entity.subtipo].scale) + "'");
                
                // arrayLocsPromise.push(this.addMarkerToMap(info))
                this.addMarkerToMap(info)
                
            } else {
                // console.log("marker ya en mapa -> " + location.nombre);
            }
        }
        
        // Promise.all(arrayLocsPromise).then(() => {
        
        // })
    }
    
    isSameLocation(latLng1, latLng2) {
        let lat1, lng1, lat2, lng2
        if (latLng1 && latLng2) {
            if (typeof latLng1.lat === "function") lat1 = latLng1.lat()
            else lat1 = latLng1.lat
            if (typeof latLng1.lng === "function") lng1 = latLng1.lng()
            else lng1 = latLng1.lng
            if (typeof latLng2.lat === "function") lat2 = latLng2.lat()
            else lat2 = latLng2.lat
            if (typeof latLng2.lng === "function") lng2 = latLng2.lng()
            else lng2 = latLng2.lng
            
            if (lat1 === lat2 && lng1 === lng2) {
                return true
            }
        }
        return false
    }
    
    
    render() {
        // console.log("MapContainer::render()");
        return (<div id="map" key={"container-" + "map"}/>);
    }
    
    
    async componentDidMount() {
        const scripts_maps_loaded = await loadGMaps()
        
        this.setState({
            ...this.state,
            scripts_maps_loaded: scripts_maps_loaded
        });
        
        $("#map").height($(window).height() - $("#map").offset()?.top || 100);
        
        await loadGMaps()
        if (typeof google !== 'undefined') googleMapsAPI = google
        if (!(typeof googleMapsAPI !== "undefined" || googleMapsAPI !== undefined)) {
            console.error("Google Maps API has not loaded yet!")
        } else {
            this.initMap()
            
            if (this.props.entitiesList) {
                this.putEntitiesInMap(this.props.entitiesList)
                this.mapFitBounds()
            }
            if (this.props.userLocation && this.props.userLocation.useUserLocation) {
                this.setUserLocationInMap()
                this.mapFitBounds()
            } else if (this.props.geoInBounds && this.props.geoInBounds.useGeoInBounds) {
                this.setBoundsMap()
            }
        }
    }
    
    
    async componentDidUpdate(prevProps, prevState) {
        let locationsAreEquals
        if (this.state.scripts_maps_loaded && googleMapsAPI) {
            if (this.props.entitiesList) {
                if (prevProps.entitiesList) {
                    locationsAreEquals = arrayEquals(this.props.entitiesList.map(l => l._id), prevProps.entitiesList.map(l => l._id))
                }
                
                if (!locationsAreEquals) {
                    this.deleteAllMarkers()
                    this.putEntitiesInMap(this.props.entitiesList)
                } else {
                    // console.log("Los locs actuales no han cambiado")
                    // this.mapFitBounds()
                }
                
                this.setViewportMap()
            } else {
                this.deleteAllMarkers()
                // this.mapFitBounds()
                if (this.props && this.props.viewport) {
                    // this.setBoundsMap(this.props.viewport);
                    this.setViewportMap()
                }
            }
            
            
            const elemButtonResults = document.getElementById("buttonResults")
            const elemResultsInMap = document.getElementById("resultInMap")
            const elemTotalResults = document.getElementById("totalResults")
            
            let numMarkersInMap = Object.keys(markersInMap).length;
            if (markersInMap[USER_LOCATION_ID]) numMarkersInMap -= 1
            if (markersInMap[CENTRO_MUNICIPIO_ID]) numMarkersInMap -= 1
            
            if (this.props && this.props.totalRecords && numMarkersInMap >= 0) {
                if (elemResultsInMap && elemTotalResults) {
                    if (elemResultsInMap) elemResultsInMap.innerHTML = numMarkersInMap.toString()
                    if (elemTotalResults) elemTotalResults.innerHTML = this.props.totalRecords
                    if (elemButtonResults) elemButtonResults.style.visibility = "visible";
                }
            } else {
                if (elemResultsInMap) elemResultsInMap.innerHTML = 0
                if (elemTotalResults) elemTotalResults.innerHTML = 0
                if (elemButtonResults) elemButtonResults.style.visibility = "visible";
            }
            
            // console.log("MapContainer::componentDidUpdate() -> mobileMode=" + this.props.config.mobileMode);
            if (!this.props.config.mobileMode) {
                this.toggleMarkerAnimation(this.props.currentElementHoverId)
            }
            if (this.props.config.mobileMode) {
                this.setMapHeight()
            }
        }
    }
}

export default MapContainer
